import { createActions, createReducer } from 'reduxsauce'

import DetalhesObrasParadasService from '../../servicos/DetalhesObrasParadasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesObrasParadasInicio: [],
    buscaDetalhesObrasParadasSucesso: ['detalhesObrasParadas'],
    buscaDetalhesObrasParadasErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDetalhesObrasParadas = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesObrasParadasInicio())
        let serv = new DetalhesObrasParadasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesObrasParadasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesObrasParadasErro(error)))
    }
}

const buscaDetalhesObrasParadasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDetalhesObrasParadasErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaDetalhesObrasParadasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.detalhesObrasParadas, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_OBRAS_PARADAS_INICIO]: buscaDetalhesObrasParadasInicio,
    [Types.BUSCA_DETALHES_OBRAS_PARADAS_ERRO]: buscaDetalhesObrasParadasErro,
    [Types.BUSCA_DETALHES_OBRAS_PARADAS_SUCESSO]: buscaDetalhesObrasParadasSucesso,
})
